import React from 'react';
import Compiler from '../compiler/Compiler';
import KovContentBlock from './KovContentBlock';

const KovSummary = ({ item }) => {
  return (
    <div className="kov-summary theme-content-synthese theme-content-synthese--importance-medium">
      <h2>
        <Compiler text={item.title} />
      </h2>

      {(item?.items || item?.children)?.map((child, i) => (
        <KovContentBlock key={i} item={child} />
      ))}
    </div>
  );
};

export default KovSummary;
